module.exports = __webpack_public_path__ + "img/42_20.60c7dac7.png";